function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartOutlined = function SvgHeartOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M143.9 259.9c-2.1 0-4.2-.9-5.7-2.4l-97.7-97.7c-30.1-30.1-30.1-79 0-109.1 14.6-14.6 34-22.6 54.6-22.6 18 0 35.1 16.1 48.9 27.4 13.8-11.3 30.8-27.4 48.9-27.4 20.6 0 40 8 54.6 22.6 30.1 30.1 30.1 79 0 109.1l-97.7 97.7c-1.7 1.6-3.8 2.4-5.9 2.4zM91.8 35.8c-17.4 0-33.7 8.7-46 21.1-25.3 25.3-28.4 66.6-3 91.9l101 102 101-102c25.3-25.3 22.3-66.6-3-91.9-12.2-12.2-28.7-21.1-46-21.1S162.1 50 149.9 62.4c-3.4 3.4-8.8 3.4-12.1 0-12.2-12.3-28.6-26.6-46-26.6z",
    style: {
      fill: "#3d3935"
    }
  }));
};
export default SvgHeartOutlined;